import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";

import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			columnDefs: [
				{ headerName: "Nombre", field: "nombre", width: "150" },
				{ headerName: "Apellido", field: "apellido", width: "150" },
				{ headerName: "Email", field: "email", width: "150" },
				{ headerName: "Telefono", field: "telefono", width: "100" },
				{ headerName: "Pais", field: "pais", width: "100" },
				{ headerName: "Sector", field: "sector", width: "80" },
				{ headerName: "Habitación", field: "habitacion", width: "80" }
			]
		};
	}

	exportFile = () => {
		/* convert state to workbook */
		let cols = this.props.users.map((info, i) => {
			return [
				info.nombre,
				info.apellido,
				info.email,
				info.telefono,
				info.pais,
				info.sector,
				info.habitacion
			];
		});
		let hcols = [
			"Nombre",
			"Apellido",
			"e-mail",
			"Telefono",
			"País",
			"Sector",
			"Habitación"
		];
		const exp = [[...hcols], ...cols];
		const ws = XLSX.utils.aoa_to_sheet(exp);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Usuarios");
		/* generate XLSX file and send to client */
		XLSX.writeFile(wb, "Usuarios.xlsx");
	};

	componentDidMount() {}

	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Usuarios</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.exportFile}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Exportar a Excel
					</Button>
				</div>
				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.users}
					></AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Users;
